(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var SWIPER_JS = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';

  function initAll() {
    document.querySelectorAll('.cc-swiper').forEach(function (el) {
      if (el.dataset.swiperInit) return;
      el.dataset.swiperInit = '1';

      var autoScroll = el.dataset.autoScroll === 'true';
      var speed      = parseInt(el.dataset.scrollSpeed, 10) || 3000;
      var desktopVis = parseFloat(el.dataset.desktop) || 7;
      var tabletVis  = parseFloat(el.dataset.tablet)  || 4;
      // FIX: schema sends integer (e.g. 2), add 0.3 peek offset for mobile
      var mobileVis  = (parseFloat(el.dataset.mobile) || 2) + 0.3;
      var gap        = parseInt(el.dataset.gap, 10)   || 16;

      var section = el.closest('.cc-section');
      var secId   = section ? section.id : '';

      new Swiper(el, {
        loop: true,
        loopAdditionalSlides: Math.ceil(desktopVis) + 2,

        slidesPerView: mobileVis,
        spaceBetween: Math.max(gap, 10),

        breakpoints: {
          600: {
            slidesPerView: tabletVis,
            spaceBetween: Math.max(gap, 14)
          },
          1024: {
            slidesPerView: desktopVis,
            spaceBetween: gap
          }
        },

        speed: 400,
        grabCursor: true,
        touchRatio: 1,
        touchAngle: 45,
        simulateTouch: true,

        navigation: {
          prevEl: secId ? '#' + secId + '-prev' : '.cc-arrow--prev',
          nextEl: secId ? '#' + secId + '-next' : '.cc-arrow--next',
          disabledClass: 'swiper-button-disabled'
        },

        pagination: {
          el: secId ? '#' + secId + '-dots' : '.cc-dots',
          clickable: true,
          bulletClass: 'swiper-pagination-bullet',
          bulletActiveClass: 'swiper-pagination-bullet-active',
          type: 'bullets'
        },

        autoplay: autoScroll ? {
          delay: speed,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
          stopOnLastSlide: false
        } : false,

        keyboard: { enabled: true, onlyInViewport: true },

        a11y: {
          enabled: true,
          prevSlideMessage: 'Previous category',
          nextSlideMessage: 'Next category'
        }
      });
    });
  }

  function loadSwiper(cb) {
    if (window.Swiper) { cb(); return; }
    var existing = document.querySelector('script[src="' + SWIPER_JS + '"]');
    if (existing) { existing.addEventListener('load', cb); return; }
    var s = document.createElement('script');
    s.src = SWIPER_JS;
    s.defer = true;
    s.onload = cb;
    document.head.appendChild(s);
  }

  loadSwiper(function () {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  });

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function () {
      loadSwiper(initAll);
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), body });
        }, 300)
      );
    }
  }

  if (!customElements.get('cart-note')) {
    customElements.define('cart-note', CartNote);
  }

  const couponCodeField = document.getElementById('coupon_code_cart');

  if (couponCodeField) {
    const savedCoupon = localStorage.getItem('coupon');

    if (savedCoupon) {
      couponCodeField.value = savedCoupon;
    }

    couponCodeField.addEventListener('input', function () {
      const value = this.value.trim();

      if (value) {
        localStorage.setItem('coupon', value);
      } else {
        localStorage.removeItem('coupon');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["most-loved"] && !Shopify.designMode) return;
  try {
    
/* ============================================================
   Most Loved — JS  (IIFE, no globals leaked)
   ============================================================ */
(function () {
  'use strict';

  var SWIPER_SRC = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';

  /* ── Wishlist toast helper ─────────────────────────────── */
  var _toastTimer = null;
  function showToast(msg, type) {
    var existing = document.getElementById('ml-wishlist-toast');
    if (existing) existing.remove();
    var toast = document.createElement('div');
    toast.id = 'ml-wishlist-toast';
    toast.className = 'ml-wishlist-toast ml-wishlist-toast--' + (type || 'info');
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.innerHTML = msg;
    document.body.appendChild(toast);
    /* Trigger animation */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { toast.classList.add('ml-wishlist-toast--visible'); });
    });
    clearTimeout(_toastTimer);
    _toastTimer = setTimeout(function () {
      toast.classList.remove('ml-wishlist-toast--visible');
      setTimeout(function () { if (toast.parentNode) toast.parentNode.removeChild(toast); }, 350);
    }, 3000);
  }

  /* ── Wishlist storage helpers ──────────────────────────── */
  var WISHLIST_KEY = 'ml-wishlist';

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]'); }
    catch (e) { return []; }
  }

  function saveWishlist(list) {
    try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(list)); }
    catch (e) { /* storage full — silently ignore */ }
  }

  function isWishlisted(productId) {
    return getWishlist().indexOf(String(productId)) !== -1;
  }

  function addToWishlist(productId) {
    var list = getWishlist();
    var id   = String(productId);
    if (list.indexOf(id) === -1) { list.push(id); saveWishlist(list); }
  }

  function removeFromWishlist(productId) {
    var list = getWishlist().filter(function (id) { return id !== String(productId); });
    saveWishlist(list);
  }

  /* ── Favourite / wishlist toggle ──────────────────────── */
  function initFavourites() {
    /* Read auth state from the section's data attributes (set server-side by Liquid) */
    var section   = document.querySelector('.ml-section[data-logged-in]');
    var loggedIn  = section && section.dataset.loggedIn === 'true';
    var loginUrl  = section && section.dataset.loginUrl
                      ? section.dataset.loginUrl
                      : '/account/login';

    document.querySelectorAll('.ml-fav').forEach(function (btn) {
      var productId = btn.dataset.productId;

      /* Restore saved wishlist state (only meaningful when logged in) */
      if (loggedIn && isWishlisted(productId)) {
        btn.classList.add('is-fav');
        btn.setAttribute('aria-pressed', 'true');
      }

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        /* ── Not logged in → redirect to login page ── */
        if (!loggedIn) {
          showToast(
            '<span class="ml-toast-icon">🔒</span> Please <strong>log in</strong> to save items to your wishlist.',
            'info'
          );
          /* Small delay so user sees the toast before navigation */
          setTimeout(function () { window.location.href = loginUrl; }, 1200);
          return;
        }

        /* ── Logged in → toggle wishlist ── */
        var faved = btn.classList.toggle('is-fav');

        if (faved) {
          addToWishlist(productId);
          showToast('<span class="ml-toast-icon">❤️</span> Added to your <strong>Wishlist</strong>!', 'added');
        } else {
          removeFromWishlist(productId);
          showToast('<span class="ml-toast-icon">🤍</span> Removed from your <strong>Wishlist</strong>.', 'removed');
        }

        /* Micro-animation */
        btn.classList.remove('pop');
        void btn.offsetWidth; /* reflow to restart */
        btn.classList.add('pop');
        btn.setAttribute('aria-pressed', faved ? 'true' : 'false');
        btn.setAttribute('aria-label',
          (faved ? 'Remove from wishlist' : 'Add to wishlist') +
          (btn.getAttribute('aria-label') ? '' : '')
        );

        /* Dispatch a custom event so other parts of the theme can react
           (e.g. a wishlist page / counter in the header) */
        document.dispatchEvent(new CustomEvent('wishlist:updated', {
          detail: { productId: productId, wishlisted: faved, wishlist: getWishlist() }
        }));
      });
    });
  }

  /* ── Variant select → live price update ──────────────── */
  function initVariantSelects() {
    document.querySelectorAll('.ml-variant-select').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var card     = sel.closest('.ml-card');
        var variantId = sel.value;
        var priceEl  = card.querySelector('.ml-card__price-current');
        var compareEl = card.querySelector('.ml-card__price--compare');
        var atcBtn   = card.querySelector('.ml-atc-btn');
        /* Find price from data attributes on the option */
        var opt = sel.querySelector('option[value="' + variantId + '"]');
        if (!opt) return;
        if (priceEl)  priceEl.textContent  = opt.dataset.price    || priceEl.textContent;
        if (compareEl && opt.dataset.compare) {
          compareEl.textContent = opt.dataset.compare;
          compareEl.style.display = '';
        } else if (compareEl) {
          compareEl.style.display = 'none';
        }
        /* Reset ATC state on variant change */
        if (atcBtn) {
          atcBtn.classList.remove('hidden');
          var qtyRow = card.querySelector('.ml-qty-row');
          if (qtyRow) { qtyRow.classList.remove('visible'); qtyRow.querySelector('.ml-qty-num').textContent = '1'; }
        }
        /* Update ATC's data-variant */
        if (atcBtn) atcBtn.dataset.variantId = variantId;
      });
    });
  }

  /* ── Add to Cart → Quantity selector ──────────────────── */
  function initATC() {
    document.querySelectorAll('.ml-atc-btn').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (btn.classList.contains('loading')) return;

        var card      = btn.closest('.ml-card');
        var variantId = btn.dataset.variantId;
        var qtyRow    = card.querySelector('.ml-qty-row');

        if (!variantId) { console.warn('[ML] No variant ID found'); return; }

        btn.classList.add('loading');

        /* Shopify AJAX add to cart */
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          btn.classList.remove('loading');
          if (data.status && data.status >= 400) {
            alert(data.description || 'Could not add to cart.');
            return;
          }
          /* Switch to qty row */
          btn.classList.add('hidden');
          if (qtyRow) { qtyRow.querySelector('.ml-qty-num').textContent = '1'; qtyRow.classList.add('visible'); }
          /* Dispatch cart update event for themes that listen */
          document.dispatchEvent(new CustomEvent('cart:updated'));
        })
        .catch(function () {
          btn.classList.remove('loading');
          alert('Something went wrong. Please try again.');
        });
      });
    });

    /* ── Quantity +/- buttons ────────────────────────────── */
    document.querySelectorAll('.ml-qty-row').forEach(function (row) {
      var card      = row.closest('.ml-card');
      var numEl     = row.querySelector('.ml-qty-num');
      var btn       = card.querySelector('.ml-atc-btn');
      var variantId = btn ? btn.dataset.variantId : null;

      function getQty() { return parseInt(numEl.textContent, 10) || 1; }

      function updateCart(newQty) {
        numEl.textContent = newQty;
        if (!variantId) return;
        if (newQty <= 0) {
          /* Remove item — switch back to ATC */
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 0 })
          }).then(function () {
            row.classList.remove('visible');
            if (btn) btn.classList.remove('hidden');
            document.dispatchEvent(new CustomEvent('cart:updated'));
          });
          return;
        }
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: newQty })
        }).then(function () {
          document.dispatchEvent(new CustomEvent('cart:updated'));
        });
      }

      row.querySelector('.ml-qty-minus').addEventListener('click', function (e) {
        e.preventDefault(); updateCart(getQty() - 1);
      });
      row.querySelector('.ml-qty-plus').addEventListener('click', function (e) {
        e.preventDefault(); updateCart(getQty() + 1);
      });
    });
  }

  /* ── Swiper init ─────────────────────────────────────── */
  function initSwipers() {
    document.querySelectorAll('.ml-swiper').forEach(function (el) {
      if (el.dataset.swiperInit) return;
      el.dataset.swiperInit = '1';

      var autoScroll  = el.dataset.auto === 'true';
      var speed       = parseInt(el.dataset.speed, 10)   || 4000;
      var desktopVis  = parseFloat(el.dataset.desktop)   || 4;
      var tabletVis   = parseFloat(el.dataset.tablet)    || 2.3;
      var mobileVis   = parseFloat(el.dataset.mobile)    || 1.2;
      var gap         = parseInt(el.dataset.gap, 10)     || 20;

      var section = el.closest('.ml-section');
      var secId   = section ? section.id : '';

      new Swiper(el, {
        loop: true,
        loopAdditionalSlides: Math.ceil(desktopVis) + 2,
        slidesPerView: mobileVis,
        spaceBetween: Math.max(gap, 12),
        breakpoints: {
          600:  { slidesPerView: tabletVis,  spaceBetween: Math.max(gap, 14) },
          1024: { slidesPerView: desktopVis, spaceBetween: gap }
        },
        speed: 380,
        grabCursor: true,
        touchRatio: 1,
        touchAngle: 45,
        simulateTouch: true,
        navigation: {
          prevEl: secId ? '#' + secId + '-prev' : '.ml-arrow--prev',
          nextEl: secId ? '#' + secId + '-next' : '.ml-arrow--next',
          disabledClass: 'swiper-button-disabled'
        },
        pagination: {
          el: secId ? '#' + secId + '-dots' : '.ml-dots',
          clickable: true,
          bulletClass: 'swiper-pagination-bullet',
          bulletActiveClass: 'swiper-pagination-bullet-active',
          type: 'bullets'
        },
        autoplay: autoScroll ? {
          delay: speed,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        } : false,
        keyboard: { enabled: true, onlyInViewport: true },
        a11y: { enabled: true, prevSlideMessage: 'Previous product', nextSlideMessage: 'Next product' }
      });
    });
  }

  /* ── Bootstrap ────────────────────────────────────────── */
  function init() {
    initFavourites();
    initVariantSelects();
    initATC();
    initSwipers();
  }

  function loadSwiper(cb) {
    if (window.Swiper) { cb(); return; }
    var ex = document.querySelector('script[src="' + SWIPER_SRC + '"]');
    if (ex) { ex.addEventListener('load', cb); return; }
    var s = document.createElement('script');
    s.src = SWIPER_SRC; s.defer = true; s.onload = cb;
    document.head.appendChild(s);
  }

  loadSwiper(function () {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  });

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function () { loadSwiper(init); });
  }

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["split-banner-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var SWIPER_SRC = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';

  /* ── Wishlist toast ──────────────────────────────────────── */
  var _toastTimer = null;
  function showToast(msg, type) {
    var existing = document.getElementById('sbc-wishlist-toast');
    if (existing) existing.remove();
    var toast = document.createElement('div');
    toast.id = 'sbc-wishlist-toast';
    toast.className = 'sbc-wishlist-toast sbc-wishlist-toast--' + (type || 'info');
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.innerHTML = msg;
    document.body.appendChild(toast);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { toast.classList.add('sbc-wishlist-toast--visible'); });
    });
    clearTimeout(_toastTimer);
    _toastTimer = setTimeout(function () {
      toast.classList.remove('sbc-wishlist-toast--visible');
      setTimeout(function () { if (toast.parentNode) toast.parentNode.removeChild(toast); }, 350);
    }, 3000);
  }

  /* ── Wishlist storage ────────────────────────────────────── */
  var WISHLIST_KEY = 'sbc-wishlist';
  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]'); } catch (e) { return []; }
  }
  function saveWishlist(list) {
    try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(list)); } catch (e) {}
  }
  function isWishlisted(id) { return getWishlist().indexOf(String(id)) !== -1; }
  function addToWishlist(id) {
    var list = getWishlist(); var sid = String(id);
    if (list.indexOf(sid) === -1) { list.push(sid); saveWishlist(list); }
  }
  function removeFromWishlist(id) {
    saveWishlist(getWishlist().filter(function (x) { return x !== String(id); }));
  }

  /* ── Favourites init ─────────────────────────────────────── */
  function initFavourites() {
    var section  = document.querySelector('.sbc-section[data-logged-in]');
    var loggedIn = section && section.dataset.loggedIn === 'true';
    var loginUrl = (section && section.dataset.loginUrl) || '/account/login';

    document.querySelectorAll('.sbc-fav').forEach(function (btn) {
      var productId = btn.dataset.productId;
      if (loggedIn && isWishlisted(productId)) {
        btn.classList.add('is-fav');
        btn.setAttribute('aria-pressed', 'true');
      }
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        if (!loggedIn) {
          showToast('<span>🔒</span> Please <strong>log in</strong> to save items to your wishlist.', 'info');
          setTimeout(function () { window.location.href = loginUrl; }, 1200);
          return;
        }
        var faved = btn.classList.toggle('is-fav');
        if (faved) { addToWishlist(productId); showToast('<span>❤️</span> Added to your <strong>Wishlist</strong>!', 'added'); }
        else { removeFromWishlist(productId); showToast('<span>🤍</span> Removed from your <strong>Wishlist</strong>.', 'removed'); }
        btn.classList.remove('pop');
        void btn.offsetWidth;
        btn.classList.add('pop');
        btn.setAttribute('aria-pressed', faved ? 'true' : 'false');
        document.dispatchEvent(new CustomEvent('wishlist:updated', {
          detail: { productId: productId, wishlisted: faved, wishlist: getWishlist() }
        }));
      });
    });
  }

  /* ── Variant select → live price update ─────────────────── */
  function initVariantSelects() {
    document.querySelectorAll('.sbc-variant-select').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var card      = sel.closest('.sbc-card');
        var variantId = sel.value;
        var opt       = sel.querySelector('option[value="' + variantId + '"]');
        if (!opt) return;
        var priceEl   = card.querySelector('.sbc-card__price-current');
        var cmpEl     = card.querySelector('.sbc-card__price--compare');
        var atcBtn    = card.querySelector('.sbc-atc-btn');
        if (priceEl) priceEl.textContent = opt.dataset.price || priceEl.textContent;
        if (cmpEl && opt.dataset.compare) { cmpEl.textContent = opt.dataset.compare; cmpEl.style.display = ''; }
        else if (cmpEl) { cmpEl.style.display = 'none'; }
        /* Reset ATC state on variant change */
        if (atcBtn) {
          atcBtn.classList.remove('hidden');
          atcBtn.dataset.variantId = variantId;
          var qtyRow = card.querySelector('.sbc-qty-row');
          if (qtyRow) { qtyRow.classList.remove('visible'); qtyRow.querySelector('.sbc-qty-num').textContent = '1'; }
        }
      });
    });
  }

  /* ── Add to Cart ─────────────────────────────────────────── */
  function initATC() {
    document.querySelectorAll('.sbc-atc-btn').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (btn.classList.contains('loading')) return;
        var card      = btn.closest('.sbc-card');
        var variantId = btn.dataset.variantId;
        var qtyRow    = card.querySelector('.sbc-qty-row');
        if (!variantId) return;
        btn.classList.add('loading');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          btn.classList.remove('loading');
          if (data.status && data.status >= 400) { alert(data.description || 'Could not add to cart.'); return; }
          btn.classList.add('hidden');
          if (qtyRow) { qtyRow.querySelector('.sbc-qty-num').textContent = '1'; qtyRow.classList.add('visible'); }
          document.dispatchEvent(new CustomEvent('cart:updated'));
        })
        .catch(function () {
          btn.classList.remove('loading');
          alert('Something went wrong. Please try again.');
        });
      });
    });

    /* Qty +/- */
    document.querySelectorAll('.sbc-qty-row').forEach(function (row) {
      var card      = row.closest('.sbc-card');
      var numEl     = row.querySelector('.sbc-qty-num');
      var atcBtn    = card.querySelector('.sbc-atc-btn');
      var variantId = atcBtn ? atcBtn.dataset.variantId : null;
      function getQty() { return parseInt(numEl.textContent, 10) || 1; }
      function updateCart(newQty) {
        numEl.textContent = newQty;
        if (!variantId) return;
        if (newQty <= 0) {
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 0 })
          }).then(function () {
            row.classList.remove('visible');
            if (atcBtn) atcBtn.classList.remove('hidden');
            document.dispatchEvent(new CustomEvent('cart:updated'));
          });
          return;
        }
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: newQty })
        }).then(function () { document.dispatchEvent(new CustomEvent('cart:updated')); });
      }
      row.querySelector('.sbc-qty-minus').addEventListener('click', function (e) { e.preventDefault(); updateCart(getQty() - 1); });
      row.querySelector('.sbc-qty-plus').addEventListener('click', function (e) { e.preventDefault(); updateCart(getQty() + 1); });
    });
  }

  /* ── Swiper init ─────────────────────────────────────────── */
  function initSwipers() {
    document.querySelectorAll('.sbc-swiper').forEach(function (el) {
      if (el.dataset.swiperInit) return;
      el.dataset.swiperInit = '1';
      var autoScroll = el.dataset.auto === 'true';
      var speed      = parseInt(el.dataset.speed, 10)  || 4000;
      var desktopVis = parseFloat(el.dataset.desktop)  || 2;
      var tabletVis  = parseFloat(el.dataset.tablet)   || 1;
      var mobileVis  = parseFloat(el.dataset.mobile)   || 1;
      var gap        = parseInt(el.dataset.gap, 10)    || 20;
      var tabletPeek = tabletVis + 0.2;
      var mobilePeek = mobileVis + 0.15;
      var section    = el.closest('.sbc-section');
      var secId      = section ? section.id : '';
      new Swiper(el, {
        loop: true,
        loopAdditionalSlides: Math.ceil(desktopVis) + 2,
        slidesPerView: mobilePeek,
        spaceBetween: Math.max(gap, 12),
        breakpoints: {
          600:  { slidesPerView: tabletPeek,  spaceBetween: Math.max(gap, 14) },
          1024: { slidesPerView: desktopVis,  spaceBetween: gap }
        },
        speed: 380,
        grabCursor: true,
        touchRatio: 1,
        touchAngle: 45,
        simulateTouch: true,
        navigation: {
          prevEl: secId ? '#' + secId + '-prev' : '.sbc-arrow--prev',
          nextEl: secId ? '#' + secId + '-next' : '.sbc-arrow--next',
          disabledClass: 'swiper-button-disabled'
        },
        pagination: {
          el: secId ? '#' + secId + '-dots' : '.sbc-dots',
          clickable: true,
          bulletClass: 'swiper-pagination-bullet',
          bulletActiveClass: 'swiper-pagination-bullet-active',
          type: 'bullets'
        },
        autoplay: autoScroll ? { delay: speed, disableOnInteraction: false, pauseOnMouseEnter: true } : false,
        keyboard: { enabled: true, onlyInViewport: true },
        a11y: { enabled: true, prevSlideMessage: 'Previous product', nextSlideMessage: 'Next product' }
      });
    });
  }

  /* ── Bootstrap ───────────────────────────────────────────── */
  function init() {
    initFavourites();
    initVariantSelects();
    initATC();
    initSwipers();
  }

  function loadSwiper(cb) {
    if (window.Swiper) { cb(); return; }
    var ex = document.querySelector('script[src="' + SWIPER_SRC + '"]');
    if (ex) { ex.addEventListener('load', cb); return; }
    var s = document.createElement('script');
    s.src = SWIPER_SRC; s.defer = true; s.onload = cb;
    document.head.appendChild(s);
  }

  loadSwiper(function () {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  });

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function () { loadSwiper(init); });
  }

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spotlight-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initSpotlightCarousel(sectionEl) {
    const track          = sectionEl.querySelector('.spotlight-track');
    const trackContainer = sectionEl.querySelector('.spotlight-track-container');
    const prevBtn        = sectionEl.querySelector('.spotlight-nav--prev');
    const nextBtn        = sectionEl.querySelector('.spotlight-nav--next');
    const dots           = sectionEl.querySelectorAll('.spotlight-dot');

    if (!track) return;

    const originalSlides = Array.from(track.children);
    const totalOriginal  = originalSlides.length;
    if (totalOriginal === 0) return;

    // ── Read config from data attributes ──
    const GAP             = parseInt(sectionEl.dataset.gap)           || 16;
    const AUTO_SCROLL     = sectionEl.dataset.autoScroll === 'true';
    const AUTO_INTERVAL   = parseInt(sectionEl.dataset.autoInterval)  || 4000;

    function getVisibleCount() {
      const w = window.innerWidth;
      if (w >= 1024) return parseInt(sectionEl.dataset.cardsDesktop) || 4;
      if (w >= 768)  return parseInt(sectionEl.dataset.cardsTablet)  || 2;
      return               parseInt(sectionEl.dataset.cardsMobile)   || 2;
    }

    let currentIndex  = 0;
    let isTransitioning = false;
    let autoTimer     = null;

    // ── Clone slides for infinite loop ──
    // We clone enough to fill at least one screen on each side.
    const maxClones = Math.max(
      parseInt(sectionEl.dataset.cardsDesktop) || 4,
      parseInt(sectionEl.dataset.cardsTablet)  || 2,
      parseInt(sectionEl.dataset.cardsMobile)  || 2
    );

    // Clone last N → prepend
    for (let i = totalOriginal - maxClones; i < totalOriginal; i++) {
      const c = originalSlides[i].cloneNode(true);
      c.setAttribute('aria-hidden', 'true');
      c.classList.add('spotlight-card--clone');
      track.insertBefore(c, track.firstChild);
    }
    // Clone first N → append
    for (let i = 0; i < maxClones; i++) {
      const c = originalSlides[i].cloneNode(true);
      c.setAttribute('aria-hidden', 'true');
      c.classList.add('spotlight-card--clone');
      track.appendChild(c);
    }

    const allSlides = Array.from(track.children);

    // ── Measure ──
    function getCardWidth() {
      return allSlides[0] ? allSlides[0].getBoundingClientRect().width : 0;
    }

    function getOffset(realIndex) {
      const clonedPos = maxClones + realIndex;
      return clonedPos * (getCardWidth() + GAP);
    }

    function setPosition(offset, animate) {
      if (!animate) track.classList.add('no-transition');
      else          track.classList.remove('no-transition');
      track.style.transform = `translateX(-${offset}px)`;
    }

    function goTo(index, animate) {
      currentIndex = ((index % totalOriginal) + totalOriginal) % totalOriginal;
      setPosition(getOffset(currentIndex), animate !== false);
      updateDots();
    }

    function updateDots() {
      dots.forEach((dot, i) => {
        const active = i === currentIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    // After transition ends, silently jump if we're in clone territory
    track.addEventListener('transitionend', () => {
      isTransitioning = false;
      // currentIndex is already normalised; just re-position without animation
      // so there's no visible jump when we loop around
      const clonedPos = maxClones + currentIndex;
      const expected  = clonedPos * (getCardWidth() + GAP);
      const currentTx = parseFloat(track.style.transform.replace('translateX(', '')) * -1 || 0;

      // Detect if we slid into a clone zone
      const totalSlides = allSlides.length;
      const lastRealPos  = (maxClones + totalOriginal - 1) * (getCardWidth() + GAP);
      const firstRealPos = maxClones * (getCardWidth() + GAP);

      // Re-anchor silently
      setPosition(getOffset(currentIndex), false);
    });

    // ── Navigate ──
    function navigate(dir) {
      if (isTransitioning) return;
      isTransitioning = true;

      const next        = currentIndex + dir;
      const clonedPos   = maxClones + next;
      const offset      = clonedPos * (getCardWidth() + GAP);

      track.classList.remove('no-transition');
      track.style.transform = `translateX(-${offset}px)`;

      // Normalise index for dots
      currentIndex = ((next % totalOriginal) + totalOriginal) % totalOriginal;
      updateDots();
    }

    // ── Auto scroll ──
    function startAuto() { if (AUTO_SCROLL) autoTimer = setInterval(() => navigate(1), AUTO_INTERVAL); }
    function stopAuto()  { clearInterval(autoTimer); }

    // ── Events ──
    prevBtn.addEventListener('click', () => { stopAuto(); navigate(-1); startAuto(); });
    nextBtn.addEventListener('click', () => { stopAuto(); navigate(1);  startAuto(); });

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        if (i === currentIndex) return;
        stopAuto();
        const dir   = i > currentIndex ? 1 : -1;
        const steps = Math.abs(i - currentIndex);
        let   count = 0;
        (function step() {
          if (count++ >= steps) { startAuto(); return; }
          navigate(dir);
          setTimeout(step, 460);
        })();
      });
    });

    // Keyboard
    trackContainer.setAttribute('tabindex', '0');
    trackContainer.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft')  { e.preventDefault(); navigate(-1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); navigate(1); }
    });

    // Touch swipe
    let tx0 = 0, ty0 = 0, swiping = false;
    trackContainer.addEventListener('touchstart', (e) => { tx0 = e.touches[0].clientX; ty0 = e.touches[0].clientY; swiping = true; }, { passive: true });
    trackContainer.addEventListener('touchend',   (e) => {
      if (!swiping) return; swiping = false;
      const dx = tx0 - e.changedTouches[0].clientX;
      const dy = Math.abs(ty0 - e.changedTouches[0].clientY);
      if (Math.abs(dx) > 40 && Math.abs(dx) > dy) navigate(dx > 0 ? 1 : -1);
    }, { passive: true });

    // Mouse drag
    let mx0 = 0, mdown = false;
    trackContainer.addEventListener('mousedown',  (e) => { mx0 = e.clientX; mdown = true; });
    trackContainer.addEventListener('mouseup',    (e) => { if (!mdown) return; mdown = false; const dx = mx0 - e.clientX; if (Math.abs(dx) > 50) navigate(dx > 0 ? 1 : -1); });
    trackContainer.addEventListener('mouseleave', ()  => { mdown = false; });

    // Resize
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => goTo(currentIndex, false), 150);
    });

    // Pause on hover/focus
    trackContainer.addEventListener('mouseenter', stopAuto);
    trackContainer.addEventListener('mouseleave', startAuto);
    trackContainer.addEventListener('focusin',    stopAuto);
    trackContainer.addEventListener('focusout',   startAuto);

    // Init
    goTo(0, false);
    startAuto();
  }

  // Boot
  document.querySelectorAll('.spotlight-carousel-section').forEach(initSpotlightCarousel);

  // Theme editor live reload
  document.addEventListener('shopify:section:load', (e) => {
    e.target.querySelectorAll('.spotlight-carousel-section').forEach(initSpotlightCarousel);
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function bootSwiper() {
    var containers = document.querySelectorAll('.tc-swiper');
    containers.forEach(function (el) {
      if (el.dataset.swiperBooted) return;
      el.dataset.swiperBooted = 'true';

      var desktop  = parseInt(el.dataset.desktop,  10) || 3;
      var tablet   = parseInt(el.dataset.tablet,   10) || 2;
      var mobile   = parseInt(el.dataset.mobile,   10) || 1;
      var gap      = parseInt(el.dataset.gap,       10) || 24;
      var doAuto   = el.dataset.autoplay === 'true';
      var interval = parseInt(el.dataset.interval, 10) || 4000;

      var swiperConfig = {
        loop:            true,
        centeredSlides:  true,
        slidesPerView:   mobile,
        spaceBetween:    gap,
        grabCursor:      true,
        a11y:            true,
        keyboard:        { enabled: true },
        breakpoints: {
          600:  { slidesPerView: tablet,  spaceBetween: gap },
          1024: { slidesPerView: desktop, spaceBetween: gap }
        },
        navigation: {
          nextEl: el.querySelector('.swiper-button-next'),
          prevEl: el.querySelector('.swiper-button-prev')
        },
        pagination: {
          el:        el.querySelector('.swiper-pagination'),
          clickable: true
        }
      };

      if (doAuto) {
        swiperConfig.autoplay = {
          delay:                interval,
          disableOnInteraction: false,
          pauseOnMouseEnter:    true
        };
      }

      /* Swiper might still be loading — retry until available */
      if (typeof Swiper !== 'undefined') {
        new Swiper(el, swiperConfig);
      } else {
        var retries = 0;
        var poll = setInterval(function () {
          if (typeof Swiper !== 'undefined') {
            clearInterval(poll);
            new Swiper(el, swiperConfig);
          }
          if (++retries > 40) clearInterval(poll); // give up after 4 s
        }, 100);
      }
    });
  }

  /* Run on DOMContentLoaded or immediately if already ready */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootSwiper);
  } else {
    bootSwiper();
  }

  /* Shopify theme editor live reload */
  document.addEventListener('shopify:section:load', bootSwiper);
})();

  } catch(e) { console.error(e); }
})();
})();
